import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TimerProvider } from './contexts/TimerContext';
import { TaskProvider } from './contexts/TaskContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';

function App() {
  return (
    <Router>
      <TimerProvider>
        <TaskProvider>
          <div className="flex flex-col min-h-screen bg-tomato-50">
            <Header />
            
            <main className="flex-grow">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
              </Routes>
            </main>
            
            <Footer />
          </div>
        </TaskProvider>
      </TimerProvider>
    </Router>
  );
}

export default App;
